export type ImportedEventType =
  | "dose"
  | "substance_use"
  | "meal"
  | "note"
  | "checkin"
  | "sleep"
  | "other";

export type TimePrecision = "exact" | "minute" | "date_only" | "unknown";
export type ImportConfidence = "high" | "medium" | "low";
export type ImportVisibility = "personal" | "clinical" | "shared";

export interface ImportedEventDraft {
  sourceApp: string;
  sourceFileName: string;
  sourceRecordId?: string;
  sourceExperienceId?: string;
  sourcePayload: unknown;
  sourceIndex?: number;
  eventType: ImportedEventType;
  occurredAt?: string;
  localDate?: string;
  timePrecision: TimePrecision;
  rawName?: string;
  canonicalSubstanceKey?: string;
  doseAmount?: number;
  doseUnit?: string;
  route?: string;
  note?: string;
  confidence: ImportConfidence;
  warnings: string[];
  excludedByDefault?: boolean;
}

export interface ImportPreviewSummary {
  total: number;
  includedByDefault: number;
  excludedDemonstrations: number;
  exactDuplicates: number;
  dateOnly: number;
  missingDoseUnit: number;
  unresolvedNames: number;
  warnings: number;
}

export interface ImportPreview {
  sourceApp: string;
  sourceFileName: string;
  events: ImportedEventDraft[];
  summary: ImportPreviewSummary;
}

export const importWarnings = {
  demo: "Registro demonstrativo: excluído por padrão.",
  dateOnly:
    "O arquivo contém apenas a data; nenhum horário foi inventado e o evento não deve entrar em curva PK/PD intradiária sem confirmação.",
  timezoneMissing:
    "Horário local sem fuso incorporado; será interpretado no fuso clínico America/Sao_Paulo.",
  doseUnitMissing: "Quantidade reconhecida, mas unidade não informada.",
  doseUnparsed: "Dose não pôde ser decomposta com segurança.",
  nameMissing: "Nome da substância ausente.",
  dateInvalid: "Data ou horário inválido.",
  duplicate: "Identificador duplicado no arquivo; registro repetido foi ignorado.",
} as const;
